/* eslint-disable react/prop-types */

import React, { useState } from 'react';
import StatusStepHeader from '../statusStepHeader';
import BackIcon from '../images/caret-left-black.svg';
import { formatCurrency } from '../../util/textMasks';

const changeInputType = (e, type) => {
  const { target } = e;

  target.type = type;

  if (target.showPicker) {
    target.showPicker();
  }
};

const changeToDate = (e) => changeInputType(e, 'date');

const closedEscrowNoteStatusIds = [86, 87, 123, 124];

const clickUpload = () => {
  const uploadButton = document.getElementById('closing-disclosure-upload');

  if (uploadButton) {
    uploadButton.click();
  }
};

const StepOne = (props) => {
  const {
    state: {
      noteable,
      noteable: {
        agent_commission,
        agent_listed_at,
        agent_closed_at,
        listing_price,
        mls_number,
        purchase_property_address,
      },
      check_details,
      check_details: {
        check_amount,
        check_date,
        check_number,
      },
      closing_info,
      closing_info: {
        title_company,
        mortgage_lender,
        loan_officer,
        loan_amount,
        interest_rate,
      },
      note_status_id,
      prior_relationship,
      currently_working,
      grouping: stateGrouping,
    },
    matchCreatedAt,
    categoryOptions,
    closingDisclosureTitle,
    mortgageLenderOptions,
    handleChange,
    handleDateBlur,
    updateState,
    collapsible,
  } = props;

  const [collapsed, setCollapsed] = useState(false);

  const handleNoteableChange = (e) => {
    const { name, value } = e.target;

    const newNoteable = { ...noteable };

    if (name === 'listing_price') {
      newNoteable[name] = formatCurrency(value);
    } else {
      newNoteable[name] = value;
    }

    updateState({ noteable: newNoteable });
  };

  const handleCheckDetailsChange = (e) => {
    const { name, value } = e.target;
    const checkDetails = { ...check_details };

    if (name === 'check_amount') {
      checkDetails[name] = formatCurrency(value);
    } else {
      checkDetails[name] = value;
    }

    updateState({ check_details: checkDetails });
  };

  const handleClosingInfoChange = (e) => {
    const { name, value } = e.target;
    const closingInfo = { ...closing_info };

    if (name === 'mortage_lender') {
      closingInfo[name] = e.target.selectedOptions[0].value;
    } else if (name === 'loan_amount') {
      closingInfo[name] = formatCurrency(value);
    } else {
      closingInfo[name] = value;
    }

    updateState({ closing_info: closingInfo });
  };

  const listingCommision = () => (
    <label>
      <span>Listing Commission, %</span>
      <div className="tooltip-wrapper">
        <input
          id="agent_commission"
          name="agent_commission"
          onChange={handleNoteableChange}
          type="number"
          value={agent_commission}
        />
      </div>
    </label>
  );

  const loadFile = ({ target }) => {
    updateState({
      closing_disclosure: target.files[0],
    });

    const button = document.getElementById('update-disclosure-button');

    if (button) {
      button.classList.add('toggle-on');
    }
  };

  const toggleYesNo = (value, btnValue) => {
    const base = "action-radio-group large-slim-font borderless mr-15 pr-10";

    return `${base} ${String(value) === String(btnValue) ? "selected" : ""}`;
  }

  const optionalFields = () => {
    let referralFormAddlDocuments = `
      We will email copies of your Referral Payment Form, W9, and Broker's
      License upon submission of this closing status update.
    `;

    if (closingDisclosureTitle.includes('Trade')) {
      referralFormAddlDocuments = referralFormAddlDocuments.replace(', W9,', '');
    }

    const statusId = note_status_id
      ? parseInt(note_status_id, 10)
      : null;

    return (
      <div className="action-details large-slim-font">
        <div className={statusId === 107 ? 'scroll-into-view' : 'hidden'}>
          <h2 className="headline-2 mb-0">Please Tell Us More</h2>
          <p>In the event that you or a delegated party conduct a transaction while representing this client or interested party, a referral fee will be owed</p>
          <div>{ `Did you have a prior relationship before ${matchCreatedAt}?` }</div>
          <div className="action-radio-groups inline-group">
            <button
              type="button"
              onClick={handleChange}
              className={toggleYesNo(prior_relationship, 1)}
              name="prior_relationship"
              value="1"
            >
            Yes
            </button>
            <button
              type="button"
              onClick={handleChange}
              className={toggleYesNo(prior_relationship, 0)}
              name="prior_relationship"
              value="0"
            >
            No
            </button>
          </div>
          <div>Are you currently working with this client?</div>
          <div className="action-radio-groups inline-group">
            <button
              type="button"
              onClick={handleChange}
              className={toggleYesNo(currently_working, 1)}
              name="currently_working"
              value="1"
            >
            Yes
            </button>
            <button
              type="button"
              onClick={handleChange}
              className={toggleYesNo(currently_working, 0)}
              name="currently_working"
              value="0"
            >
            No
            </button>
          </div>
          <textarea
              maxlength="1000"
              name="prior_relationship_message"
              class="large-slim-font rea-black"
              placeholder="Please provide any additional details here"
              onChange={handleChange}
              onFocus={handleChange}
              onBlur={handleChange}
          ></textarea>
        </div>
        <div className={statusId === 84 ? 'scroll-into-view' : 'hidden'}>
          <h2 className="headline-2">Selling Commission (optional)</h2>
          {listingCommision()}
        </div>
        <div className={statusId === 85 ? 'scroll-into-view' : 'hidden'}>
          <label>
            <span>Listing Date</span>
            <input
              min="2021-11-05"
              name="agent_listed_at"
              onChange={handleNoteableChange}
              onFocus={changeToDate}
              onBlur={handleDateBlur}
              placeholder="Select date"
              pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
              type="text"
              value={agent_listed_at}
            />
          </label>
          <label>
            <span>Listing Price</span>
            <input
              className="currency-mask"
              name="listing_price"
              onChange={handleNoteableChange}
              placeholder="Listing Price"
              type="text"
              value={listing_price}
            />
          </label>
          <label>
            <span>MLS #</span>
            <input
              name="mls_number"
              onChange={handleNoteableChange}
              type="text"
              value={mls_number}
            />
          </label>
          {listingCommision()}
        </div>
        <div className={closedEscrowNoteStatusIds.includes(statusId) ? 'scroll-into-view' : 'hidden'}>
          <h2>Closing Information</h2>
          <label>
            <span>Closing Date</span>
            <input
              min="2021-11-05"
              name="agent_closed_at"
              onBlur={handleDateBlur}
              onChange={handleNoteableChange}
              onFocus={changeToDate}
              pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
              placeholder="Select closing date"
              type="text"
              value={agent_closed_at}
            />
          </label>
          {listingCommision()}
          <label>
            <span>Purchase Property Address</span>
            <input
              name="purchase_property_address"
              onChange={handleNoteableChange}
              type="text"
              value={purchase_property_address}
            />
          </label>
          <h2>Referral Check Details</h2>
          <label>
            <span>Check Number</span>
            <input
              name="check_number"
              onChange={handleCheckDetailsChange}
              type="text"
              value={check_number}
            />
          </label>
          <label>
            <span>Check Amount</span>
            <input
              className="currency-mask"
              name="check_amount"
              onChange={handleCheckDetailsChange}
              type="text"
              value={check_amount}
            />
          </label>
          <label>
            <span>Check Date</span>
            <input
              min="2021-11-05"
              name="check_date"
              onBlur={handleDateBlur}
              onChange={handleCheckDetailsChange}
              onFocus={changeToDate}
              type="text"
              value={check_date}
            />
          </label>
          <h2>Mortgage Information</h2>
          <label>
            <span>Name of Financing/Mortage Provider</span>
            <div className="select-wrapper">
              <select
                name="mortgage_lender"
                value={mortgage_lender}
                onChange={handleClosingInfoChange}
              >
                <option value="">Name of Financing/Mortage Provider</option>
                {
                  mortgageLenderOptions.map((opt, idx) => (
                    <option key={idx} value={opt}>{opt}</option>
                  ))
                }
              </select>
            </div>
          </label>
          <label>
            <span>Client&apos;s Loan Officer</span>
            <input
              name="loan_officer"
              onChange={handleClosingInfoChange}
              type="text"
              value={loan_officer}
            />
          </label>
          <label>
            <span>Client&apos;s Loan Amount</span>
            <input
              className="currency-mask"
              name="loan_amount"
              onChange={handleClosingInfoChange}
              type="text"
              value={loan_amount}
            />
          </label>
          <label>
            <span>Client&apos;s Loan Interest Rate</span>
            <input
              name="interest_rate"
              onChange={handleClosingInfoChange}
              placeholder="Client's Loan Interest Rate"
              type="text"
              value={interest_rate}
            />
          </label>
          <label>
            <span>Your Title Company</span>
            <input
              name="title_company"
              onChange={handleClosingInfoChange}
              type="text"
              value={title_company}
            />
          </label>
          <div className="disclosure-box">
            <h3>{closingDisclosureTitle}</h3>
            <p>
              Please remember to send a copy of the&nbsp;
              {closingDisclosureTitle}
              &nbsp;with your referral check.
              Thank you.
            </p>
            <button
              id="update-disclosure-button"
              onClick={clickUpload}
              type="button"
            >
              UPLOAD&nbsp;
              {closingDisclosureTitle}
            </button>
            <input
              id="closing-disclosure-upload"
              type="file"
              onChange={loadFile}
            />
          </div>
          <h3>Referral Payment Form</h3>
          <p>
            You must fill out and submit the Referral Payment Form with your referral check.
          </p>
          <p>
            <b>
              {referralFormAddlDocuments}
            </b>
          </p>
        </div>
      </div>
    );
  };

  const selectGrouping = (value) => {
    const newValue = value === stateGrouping ? null : value;

    updateState({
      grouping: newValue,
      note_status_id: '',
    });
  };

  const category = (opt, index) => {
    const categoryKey = `category-${index}`;
    const {
      grouping_column,
      options,
    } = opt;

    const selected = stateGrouping === grouping_column;

    const reasonClassList = ['options-reason'];

    if (selected) {
      reasonClassList.push('selected');
    }

    const arrowClassList = [
      'options-arrow',
      ...(!selected ? ['selected'] : []),
    ];
    // !selected to act contrarily to the default css class behavior

    return (
      <div className={reasonClassList.join(' ')} key={categoryKey}>
        <div className="options-header">
          <button
            className="action-option-reason large-slim-font"
            onClick={selectGrouping.bind(null, grouping_column)}
            type="button"
          >
            <span>
              {grouping_column}
            </span>
            <img
              alt=""
              className={arrowClassList.join(' ')}
              src={BackIcon}
            />
          </button>
        </div>
        {
          selected
          && (
            <div className="reason-options">
              <div className="action-form">
                <div className="action-radio-groups">
                  {
                    options.map(({ display, id }, i) => {
                      const optionKey = `category-${index}-option-${i}`;
                      const buttonClassList = ['action-radio-group', 'large-slim-font'];

                      if (parseInt(note_status_id, 10) === id) {
                        buttonClassList.push('selected');
                      }

                      return (
                        <button
                          type="button"
                          key={optionKey}
                          className={buttonClassList.join(' ')}
                          onClick={handleChange}
                          name="note_status_id"
                          value={id}
                        >
                          {display}
                        </button>
                      );
                    })
                  }
                </div>
                {optionalFields()}
              </div>
            </div>
          )
        }
      </div>
    );
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const header = () => {
    const arrowClassList = ['options-arrow'];

    if (collapsed) {
      arrowClassList.push('selected');
    }

    if (collapsible) {
      return (
        <div className="action-headline">
          <button
            type="button"
            className="collapse-button"
            onClick={toggleCollapsed}
          >
            <StatusStepHeader
              step="1"
              stepComplete={!!note_status_id}
              collapsible={collapsible}
            >
              Choose a new status
            </StatusStepHeader>
            <img
              alt=""
              className={arrowClassList.join(' ')}
              src={BackIcon}
            />
          </button>
        </div>
      );
    }

    return (
      <div className="action-headline">
        <StatusStepHeader
          step="1"
          stepComplete={!!note_status_id}
          collapsible={collapsible}
        >
          Choose a new status
        </StatusStepHeader>
      </div>
    );
  };

  const bodyClassList = ['notify-loop-action-body'];

  if (collapsed) {
    bodyClassList.push('collapsed');
  }

  return (
    <div className="step-1">
      <div className={bodyClassList.join(' ')}>
        {header()}
        <div className="action-options">
          {
            categoryOptions.map(category)
          }
        </div>
      </div>
    </div>
  );
};

export default StepOne;

StepOne.defaulProps = {
  collapsible: false,
};
